module.exports = __webpack_public_path__ + "img/spicing_slip_btn.0d836bf7.png";